import { useCallback } from 'react'

export interface IUseCopyToClipboard {
    onSuccess?: () => void
    onError?: () => void
}

export const useCopyToClipboard = ({ onSuccess, onError }: IUseCopyToClipboard = {}) => {
    const copyToClipboard = useCallback(
        (text: string) =>
            // `navigator.clipboard` is undefined outside a secure context (a plain-http LAN dev host
            // or preview), where `.writeText` throws SYNCHRONOUSLY — before any promise exists, so
            // the `.catch` below never runs and the caller gets an uncaught TypeError and no toast.
            // Promise.reject routes that case through the same onError path as a denied permission.
            (navigator.clipboard?.writeText(text) ?? Promise.reject(new Error('Clipboard unavailable')))
                .then(() => {
                    onSuccess?.()

                    return text
                })
                .catch((err) => {
                    onError?.()

                    return err
                }),
        [onSuccess, onError]
    )

    return { copyToClipboard }
}
